import { useMemo } from 'react';
import { ApolloError } from '@apollo/client/errors';
import {
  EnabledGroupTypesDocument,
  EnabledGroupTypesQuery,
  EnabledGroupTypesQueryVariables
} from 'graphql/types';
import usePersistedCacheQuery from 'modules/common/hooks/usePersistedCacheQuery';

export const useEnabledGroupTypes = (): {
  data: EnabledGroupTypesQuery | undefined;
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const { loading, data, error } = usePersistedCacheQuery<
    EnabledGroupTypesQuery,
    EnabledGroupTypesQueryVariables
  >(EnabledGroupTypesDocument, {});
  return useMemo(
    () => ({
      loading,
      error,
      data
    }),
    [data, error, loading]
  );
};
